import React from 'react';
import { cn } from '../../utils/cn';

const baseStyles =
  'inline-flex items-center justify-center rounded-full font-medium transition-all duration-300 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';

const variants = {
  default:
    'bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-lg hover:shadow-primary/20 hover:-translate-y-0.5 active:translate-y-0',
  outline:
    'border border-input bg-background hover:bg-accent hover:text-accent-foreground hover:border-primary/30',
  secondary:
    'bg-secondary text-secondary-foreground hover:bg-secondary/80 hover:-translate-y-0.5',
  ghost: 'hover:bg-accent hover:text-accent-foreground',
  link: 'underline-offset-4 hover:underline text-primary',
  xlink:
    'bg-foreground text-background hover:opacity-90 hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0',
};

const sizes = {
  sm: 'h-10 px-3 text-sm',
  md: 'h-12 py-2 px-4',
  lg: 'h-12 px-8',
};

// Button と同じ見た目を Link 等の別要素に適用するためのヘルパー
export const buttonVariants = ({
  variant = 'default',
  size = 'md',
  className = '',
} = {}) => cn(baseStyles, variants[variant], sizes[size], className);

const isExternalHref = href => /^https?:\/\//.test(href || '');

const Button = ({
  children,
  variant = 'default',
  size = 'md',
  className = '',
  icon: Icon,
  href,
  ...props
}) => {
  const ButtonOrLink = href ? 'a' : 'button';
  const isExternal = isExternalHref(href);

  return (
    <ButtonOrLink
      className={buttonVariants({ variant, size, className })}
      href={href}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      {...props}
    >
      {Icon && <Icon className="w-5 h-5 mr-2" />}
      {children}
    </ButtonOrLink>
  );
};

export default Button;
